/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-named-as-default-member */
import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { Auth, API } from 'aws-amplify'
import { CardElement, injectStripe } from 'react-stripe-elements'
import * as Sentry from '@sentry/browser'
import uuidv4 from 'uuid/v4'
import Button from './Button'
import Spinner from './Spinner'
// eslint-disable-next-line import/no-duplicates
import BookingLib from '../lib/booking'
// eslint-disable-next-line import/no-duplicates
import {
  postStripeCustomer,
  postStripeOrder,
  // postStripeOrderPayment,
  updatePaymentIntent,
  postBooking,
  putReleaseReservation,
  postInvitation,
  spoofPaymentWebhook
// eslint-disable-next-line import/no-duplicates
} from '../lib/booking'
// eslint-disable-next-line import/no-duplicates
import AuthenticatedAPI from '../lib/authenticatedAPI'
import buildBookingOrder from '../lib/buildBookingOrder'
import buildStripeItems from '../lib/buildStripeItems'

class StripePaymentForm extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      showError: false
    }
    this.updateOrder = this.updateOrder.bind(this)
    this.onPaymentCompleted = props.onPaymentCompleted.bind(this)
    this.postPaymentIntent = this.postPaymentIntent.bind(this)
  }

  componentDidMount() {
    const { skus } = this.props
    if (skus.length > 0) { // SKUs might not be loaded yet (mostly on page reload)
      this.postPaymentIntent(skus, { initiatedBy: 'componentDidMount' })
    }
    this.setUserState()
  }

  componentWillReceiveProps(nextProps) {
    const { skus } = this.props

    // SKUs might not be loaded yet (mostly on page reload)
    if (skus.length !== nextProps.skus.length) {
      this.postPaymentIntent(nextProps.skus, { initiatedBy: 'componentWillReceiveProps'})
    }
  }

  async setUserState() {
    const [user, userInfo] = await Promise.all([
      Auth.currentAuthenticatedUser(),
      AuthenticatedAPI.get('cphill', '/users')
    ])
    this.setState({ user, userInfo })
  }  

  isPayable = () => {
    const { booking, skus, overrideHours } = this.props
    const { user = {} } = this.state
    const { email } = user.attributes || {}
    return BookingLib.totalBookingSum(booking, skus, overrideHours, email) > 0
  }
  
  async postPaymentIntent(skus, extraMeta) {
    const { props, state } = this
    const { booking, overrideHours } = props

    const userInfo = state.userInfo || await AuthenticatedAPI.get('cphill', '/users')
    const { email, firstName, lastName } = userInfo

    if (!state.paymentIntent && BookingLib.totalBookingSum(booking, skus, overrideHours, email) > 0) { // In case this get's called multiple times by componentDidMount/componentWillReceiveProps
      const paymentIntent = await API.post('cphill', '/stripe/proxy', {
        body: {
          endpoint: 'paymentIntents.create',
          parameters: {
            amount: BookingLib.totalBookingSum(booking, skus, overrideHours, email) * 100,
            currency: 'DKK',
            metadata: { 
              email,
              ...(firstName && { firstName }),
              ...(lastName && { lastName }),
              ...extraMeta
            }
          }
        }
      })
      this.setState({ paymentIntent })
    }
  }
  
  async updateOrder(e, optionalIdempotencyKey) {
    e.preventDefault()

    const { props, state } = this
    const { stripe, booking, skus, overrideHours } = props
    const { email } = state.user && state.user.attributes || {}
    
    if (!props.isValid() || props.atUserBookingsCapacity) {
      return false
    }

    this.setState({ isLoading: true, showError: false })

    // Prepare booking orders for submit on successful payment
    const bookingOrders = booking.people.filter(p => !p.invite).map(person => buildBookingOrder(person, booking, skus, props.intl, overrideHours, email))    
    const isPayable = this.isPayable()

    try {
      const user = state.user || await Auth.currentAuthenticatedUser()
      const userInfo = state.userInfo || await AuthenticatedAPI.get('cphill', '/users')

      let { stripeCustomerId } = userInfo
      if (!stripeCustomerId && isPayable) {

        // Create Stripe token
        const tokenObj = await stripe.createToken({
          name: user.attributes.email
        })
        const { token } = tokenObj
        if (!token) {
          throw (tokenObj && tokenObj.error) || new Error("No token and no error msg from Stripe")
        }
        
        // Create Stripe customer
        const stripeCustomer = await postStripeCustomer(user, userInfo, token)
        stripeCustomerId = stripeCustomer.id
        
        // update userInfo with new Stripe Customer
        await AuthenticatedAPI.put('cphill', '/users', { stripeCustomerId })
        this.setUserState()
      }

      // Create Stripe order
      const key = optionalIdempotencyKey || booking.key
      const stripeOrder = await postStripeOrder(user, stripeCustomerId, buildStripeItems(booking, skus, overrideHours, email), key)

      if (stripeOrder.amount !== BookingLib.totalBookingSum(booking, skus, overrideHours, email) * 100) {
        throw new Error(`Payment amount not the same as cart amount! ${stripeOrder.amount} - ${BookingLib.totalBookingSum(booking, skus, overrideHours, email) * 100}`);
      }

      // Post booking
      const bookingResult = await postBooking(booking, bookingOrders, stripeOrder, skus, props.intl, overrideHours, email)
            
      if (isPayable) {
        // Update payment intent with customer & metadata
        if (!state.paymentIntent || !state.paymentIntent.id || !stripeCustomerId) {
          throw new Error("Payment was not completed")
        }
      
        await updatePaymentIntent(state.paymentIntent.id, stripeCustomerId, {
          bookingId: bookingResult.id,
          order_id: stripeOrder.id // 'order_id' because stripe names it that way (not camelcase)
        })    

        // Pay Stripe order
        const paymentConfirmation = await stripe.handleCardPayment(state.paymentIntent.client_secret)
        if (paymentConfirmation && paymentConfirmation.error) {
          throw paymentConfirmation.error
        }
      } else {
        // Spoof webhook when no actual payment happened
        await spoofPaymentWebhook(bookingResult, stripeOrder)
      }

      // NOTE: This as been (hopefully temporarily) disabled cause Stripe presently doesn't support it with SCA (Strong Customer Auth)
      // const stripePayment = await postStripeOrderPayment(stripeOrder, stripeCustomerId, bookingResult.id)

      // update booking w. chargeId
      await AuthenticatedAPI.put('cphill', `/bookings/${bookingResult.id}`, { 
        stripeChargeId: isPayable ? state.paymentIntent.id : 'NO_CHARGE'
      })

      // send invitations + release reservation
      if (booking.invitation) {
        try {
          // Don't important to wait for it to finish
          API.put('cphill', `/invitations/${booking.invitation.uuid}`, {
            body: {
              acceptedAt: new Date(),
              acceptedByUserId: userInfo.id,
              acceptedBookingId: bookingResult.id 
            }
          })
        } catch(error) {
          // Don't fail hard, as not so important as getting through booking
          Sentry.captureException(error)
        }
      } else {
        try {
          const invitePeople = booking.people.filter(p => p.invite)
          const invitesPromises = invitePeople.map(person => postInvitation(person, bookingResult))
          // Don't important to wait for it to finish
          Promise.all([...invitesPromises, putReleaseReservation(booking, bookingResult)])
        } catch(error) {
          // Don't fail hard, as not so important as getting through booking
          Sentry.captureException(error)  
        }
      }
      this.onPaymentCompleted()
      
    } catch (error) {
      this.setState({
        isLoading: false,
        showError: true,
        errorType: error.type,
        errorMessage: error.message
      })
      this.postPaymentIntent(skus, { initiatedBy: 'updateOrder catch error', errorMessage: error.message }) // To trigger new paymentIntent in case the user attempts a re-try (been know to vanish mysteriously)

      if (error.type && error.type !== "validation_error") {
        Sentry.configureScope((scope) => { scope.setUser({ email: state.userInfo && state.userInfo.email }) })
        Sentry.configureScope((scope) => { scope.setExtra('bookingOrders', bookingOrders) })
        // Sentry.captureException(error)
      }
    }
    
    return true
  }

  render() {
    const { props } = this
    const { isLoading, showError, errorMessage, errorType } = this.state

    return (
      <>
        <div className={`${!isLoading && ('hidden')}`}>
          <Spinner />
        </div>
      
        <form onSubmit={this.updateOrder} className={`${isLoading && ('invisible')}`}>
          <div className="sm:w-2/3 lg:w-1/2">
            <label htmlFor="cardnumber" className={`${props.skus.length > 0 && this.isPayable() ? 'visible' : 'hidden' } `}>
              <div className="uppercase text-sky font-bold">
                <FormattedMessage
                  id="booking.payment.labelCardNo"
                  defaultMessage="Card details"
                />
              </div>
              <CardElement
                className="border rounded-full bg-white px-4 py-3 text-sm"
              // onBlur={handleBlur}
              // onChange={handleChange}
              // onFocus={handleFocus}
              // onReady={handleReady}
              // {...createOptions(this.props.fontSize)}
              />
            </label>

            {showError && (
              <div className="text-sm my-4 bg-red-lightest border-l-2 border-red text-red-dark p-2" role="alert">
                <>
                  <p className="m-0 font-bold">
                    {errorMessage}
                  </p>
                  {!['validation_error'].includes(errorType) && (
                    <>
                      <p className="m-0 mt-4">
                        <FormattedMessage
                          id="booking.payment.errorText"
                          defaultMessage="Payment failed"
                        />
                      </p>
                      <button
                        onClick={e => { this.updateOrder(e, uuidv4()) }}
                        className="px-6 py-2 my-4 rounded-full bg-red-dark text-white font-bold uppercase tracking-wide-2xl"
                        type="button"
                      >
                        <FormattedMessage
                          id="booking.payment.errorButtonText"
                          defaultMessage="Try it again"
                        />
                      </button>
                    </>
                  )}
                </>
              </div>
            )}

            { showError && (
              <p className="text-red">
                <FormattedMessage
                  id="booking.payment.errorText2"
                  defaultMessage="Having payment issues? Call +45 7196 7197"
                />
              </p>
            )}

            <img
              src="https://www.copenhill.dk/user/themes/copenhill/images/creditcards.png?cache1"
              alt="Creditcards"
              className="h-16 -ml-2 mt-4"
            />
          </div>
          <div className="flex justify-end mt-4">
            <Button
              // onClick={this.updateOrder}
              className={`
                whitespace-no-wrap
                ${(!props.isValid() || props.atUserBookingsCapacity)
                  && 'opacity-50 cursor-not-allowed'}
              `}
            >
              <FormattedMessage
                id="booking.payment.buttonSubmit"
                defaultMessage="Submit payment"
              />
            </Button>
          </div>
        </form>
      </>
              
    )
  }
}

StripePaymentForm.propTypes = {
  onPaymentCompleted: PropTypes.func.isRequired,
  booking: PropTypes.shape({
    booking: PropTypes.object
  }).isRequired,
  skus: PropTypes.arrayOf(PropTypes.object).isRequired,
  overrideHours: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default injectIntl(injectStripe(StripePaymentForm))
